var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.24000000000000005
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22L2 22",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22V6C17 4.11438 17 3.17157 16.4142 2.58579C15.8284 2 14.8856 2 13 2H11C9.11438 2 8.17157 2 7.58579 2.58579C7 3.17157 7 4.11438 7 6V22",
    stroke: "#ffffff",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22V11.5C21 10.0955 21 9.39331 20.6629 8.88886C20.517 8.67048 20.3295 8.48298 20.1111 8.33706C19.6067 8 18.9045 8 17.5 8",
    stroke: "#ffffff",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 22V11.5C3 10.0955 3 9.39331 3.33706 8.88886C3.48298 8.67048 3.67048 8.48298 3.88886 8.33706C4.39331 8 5.09554 8 6.5 8",
    stroke: "#ffffff",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V19",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5H14",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8H14",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11H14",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14H14",
    stroke: "#ffffff",
    strokeWidth: 1.08,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.0cb0fb441d8d04ff668f669acd4644d5.svg";
export { ForwardRef as ReactComponent };